import { slugFromLabel } from '../utils/markdownPaths';

export const DB_PREFIX = 'database/';

/** Journal for game analyses from the Chess page (## Games section). */
export const CHESS_JOURNAL_PATH = 'database/chess.md';
export const CHESS_JOURNAL_SECTION = 'Games';
/** Published by the daily-report workflow (same HTML as the morning email). */
export const DASHBOARD_HTML_PATH = 'database/daily-dashboard.html';

/* One starter file only when database/ has no .md files yet. */
export const DATABASE_INIT_FILES: ReadonlyArray<{ path: string; body: string }> = [
  {
    path: 'database/getting-started.md',
    body: `# Getting started

## Welcome

All pages for this app live under the database/ folder. You can use any subfolders and file names you want.

`,
  },
];

export function markdownPathFromImportName(parentDir: string, fileName: string): string | null {
  const base = fileName.replace(/\\/g, '/').split('/').pop()?.trim() ?? '';
  if (!base) return null;
  const stem = /\.md$/i.test(base) ? base.slice(0, -3) : base;
  const slug = slugFromLabel(stem);
  if (!slug) return null;
  return `${parentDir.replace(/\/$/, '')}/${slug}.md`;
}
